const Colors = {
  colYellow: "#ffd967",
  colPrimaryYellow: "#ffba00",
  colPurple: "#305CC5",
  colHeaderBlue: "#305cc6",
  colRed: "#E53935",
  colBlack: "#363636",
  colDarkerGrey: "#2F3033",
  colDarkGrey: "#DDDDDD",
  colLighterBlue: "#E2F2F7",
  colPaleGrey: "#EEF3F8",
  colLightGrey: "#F5FAFC",
  colLightBlue: "#f3f7fa",
  colWhite: "#FFFFFF",
  hint: "#bdc3d2"

};

export default Colors;



// WEBPACK FOOTER //
// ./src/assets/Colors.ts